<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter-title">ACKNOWLEDGMENTS</h2>
<p class="flush-left">Writing is a solitary business, yet it takes a team to put a novel into the hands of readers. With thanks to my incredible team:</p>
<p class="indented">My husband, Barry Talley, who turns down the TV and slips thin food under my office door whenever I’m on deadline.</p>
<p class="indented">My editor, Sara Porter, my can-do publicist, Michelle Duff, publisher Edwin Buckhalter and everyone else at Severn House who makes it such an incredibly supportive place for a mystery writer to be.</p>
<p class="indented">Historic Annapolis Foundation and the staff of the William Paca House for allowing my imaginary LynxE production team and cast to move in, particularly Alexandra Deutsch, Curator (2004–2008); Glenn Campbell, Historian; and Scotti Preston, Living History/Special Projects Coordinator.</p>
<p class="indented">Joseph Gagliardi, M.A., M.D. who practices medicine both in the past (as Doctor A. Dobbs) and in the present as Medical Director of the Detox Center of Central Maryland, in Columbia, Maryland.</p>
<p class="indented">Lt Paul Wood, USN, for . . . well, if I told you, he’d have to kill me.</p>
<p class="indented">And once again, my fellow travelers at various stations on the road to publication, the Annapolis Writers Group: Ray Flynt, Lynda Hill, Mary Ellen Hughes, Debbi Mack, Sherriel Mattingley, and Bonnie Settle for tough love.</p>
<p class="indented">To Kate Charles and Deborah Crombie who are always there to help out whenever the muse takes a vacation.</p>
<p class="indented">And, of course, to Vicky Bijur.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?6382a984